import type { EnrichedPortfolioReport } from '../hooks/usePortfolioTableState.types';
import type { PortfolioReport } from '../types';
import { calculateDrift } from './index';

export function enrichPortfolioReport(
  report: PortfolioReport,
): EnrichedPortfolioReport {
  return {
    ...report,
    _drift: calculateDrift(report),
  };
}
